import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DashboardView from "./routes/DashboardView";

export default store => {
  return {
    path: "all-dashboards",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import(/* webpackChunkName: "ai" */ "./components")]).then(
          ([importedModule0]) => {
            const component = importedModule0.default;
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [DashboardView(store)],
  };
};
